import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const PartnersFilled: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="1"
      y="9.23535"
      width="5.76469"
      height="5.76469"
      rx="0.823527"
      fill="currentColor"
    />
    <rect
      x="9.23535"
      y="9.23535"
      width="5.76469"
      height="5.76469"
      rx="0.823527"
      fill="currentColor"
    />
    <rect
      x="9.23535"
      y="1"
      width="5.76469"
      height="5.76469"
      rx="0.823527"
      fill="currentColor"
    />
    <rect
      x="1"
      y="1"
      width="5.76469"
      height="5.76469"
      rx="0.823527"
      fill="currentColor"
    />
  </svg>
);
